import { ACADEMY_CATALOG_SERVICE_URI_V2 } from '../../constants/ApiConstants';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import http from 'hub-http/clients/apiClient';
import { useCallback, useMemo } from 'react';
import { GET_ALL_PROGRESS, GET_PLAYLIST_PROGRESS } from '../userProgress/userProgressQueries';
import Raven from 'raven-js';
import { useStartShortProgress } from 'academy-common-lib/features/userProgress/hooks/useStartShortProgress';
export const SHORTS_API = `${ACADEMY_CATALOG_SERVICE_URI_V2}/shorts/`;
const GET_SHORT = registerQuery({
  fieldName: 'shorts',
  args: ['shortId'],
  fetcher: ({
    shortId
  }) => http.get(`${SHORTS_API}${shortId}`)
});
export const useFullShort = (shortId, skip) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_SHORT, {
    skip,
    variables: {
      shortId
    }
  });
  return {
    short: data,
    shortLoading: loading,
    shortError: error
  };
};
const GET_ALL_SHORTS = registerQuery({
  fieldName: 'shorts',
  args: [],
  fetcher: () => http.get(`${SHORTS_API}`)
});
export const useAllShorts = skip => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_ALL_SHORTS, {
    skip,
    variables: {}
  });
  return {
    allShorts: data,
    allShortsLoading: loading,
    allShortsError: error
  };
};
export const useShort = (shortId, skip) => {
  const {
    allShorts,
    allShortsLoading,
    allShortsError
  } = useAllShorts(skip);
  const short = useMemo(() => (allShorts === null || allShorts === void 0 ? void 0 : allShorts.find) && allShorts.find(s => s.contentId === shortId), [allShorts, shortId]);
  return {
    short,
    shortLoading: allShortsLoading,
    shortError: allShortsError
  };
};
export const useStartShort = (shortId, language, playlistId) => {
  const [mutate, {
    loading: startShortLoading,
    called: startShortCalled,
    error: startShortError,
    data: startShortData
  }] = useStartShortProgress();
  const startShort = useCallback(() => {
    return mutate({
      awaitRefetchQueries: true,
      variables: {
        shortId,
        language,
        playlistId
      },
      refetchQueries: [{
        query: GET_ALL_PROGRESS,
        variables: {
          language
        },
        context: {
          timeout: 25000
        }
      }, ...(playlistId ? [{
        query: GET_PLAYLIST_PROGRESS,
        variables: {
          playlistId
        }
      }] : [])],
      onError(error) {
        Raven.captureException(error);
      }
    });
  }, [language, mutate, playlistId, shortId]);
  return [startShort, {
    startShortLoading,
    startShortCalled,
    startShortError,
    startShortData
  }];
};